import React from 'react';
import PropTypes from 'prop-types';

import { isPreorder, updateAccessbilityContent } from '../../../../common/Helpers/index';
import Heading from '../../../../common/Heading/head';

const DeviceSetupHeading = ({ deviceSetUpHeading = '', singleColHeading = '', deviceSetUpPreOrderHeading = '', eligible5GHomeBundle }) => {
  let deviceHeading = eligible5GHomeBundle && eligible5GHomeBundle.length < 2 ? singleColHeading : deviceSetUpHeading;
  if (isPreorder()) {
    deviceHeading = deviceSetUpPreOrderHeading;
  }
  updateAccessbilityContent(deviceHeading);
  return <Heading heading={deviceHeading} />;
};

export default DeviceSetupHeading;

DeviceSetupHeading.propTypes = {
  singleColHeading: PropTypes.string,
  deviceSetUpHeading: PropTypes.string,
  eligible5GHomeBundle: PropTypes.array,
  deviceSetUpPreOrderHeading: PropTypes.string,
};
